var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomizableExperience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_677)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.39 67.8559C126.802 67.8346 126.771 67.3556 128.128 73.1037C128.985 76.7336 129.943 80.3368 130.805 83.9613C131.023 84.8715 131.475 85.3611 132.375 85.606C134.69 86.2393 136.909 87.1494 138.996 88.3363C139.82 88.8047 140.443 88.8047 141.257 88.3044C145.153 85.9147 149.081 83.5835 153.004 81.2363C155.005 80.0388 155.947 80.1505 157.586 81.7739C158.815 82.9927 160.039 84.2115 161.248 85.4516C162.621 86.862 162.754 87.9212 161.732 89.6403C159.395 93.5682 157.054 97.4961 154.664 101.387C154.116 102.276 153.956 102.967 154.542 103.947C155.739 105.959 156.623 108.141 157.208 110.408C157.469 111.425 158.028 111.824 158.98 112.058C163.467 113.144 167.948 114.267 172.424 115.411C174.431 115.922 174.973 116.657 174.984 118.716C174.995 120.558 174.995 122.399 174.984 124.241C174.968 126.157 174.377 126.955 172.488 127.434C168.012 128.579 163.536 129.702 159.044 130.782C158.028 131.027 157.469 131.474 157.181 132.544C156.58 134.806 155.665 136.972 154.499 139.005C154.025 139.83 154.036 140.453 154.542 141.267C156.931 145.163 159.268 149.091 161.609 153.014C162.796 155.004 162.679 155.962 161.061 157.596C159.842 158.826 158.629 160.055 157.389 161.263C155.984 162.631 154.914 162.759 153.195 161.732C149.267 159.39 145.345 157.053 141.449 154.658C140.555 154.11 139.863 153.972 138.889 154.546C136.872 155.739 134.69 156.617 132.423 157.218C131.417 157.484 131.007 158.022 130.773 158.991C129.698 163.483 128.564 167.959 127.43 172.435C126.93 174.404 126.169 174.979 124.12 174.99C122.279 175 120.437 175 118.596 174.99C116.674 174.974 115.881 174.367 115.408 172.488C114.274 168.012 113.14 163.536 112.06 159.044C111.815 158.027 111.379 157.463 110.298 157.186C108.031 156.596 105.87 155.675 103.837 154.509C103.012 154.036 102.395 154.046 101.575 154.546C97.6849 156.942 93.7571 159.278 89.8294 161.615C87.8176 162.812 86.8756 162.684 85.247 161.072C84.0176 159.853 82.7935 158.634 81.58 157.399C80.1909 155.978 80.0632 154.956 81.0957 153.216C83.4321 149.288 85.7739 145.365 88.1635 141.469C88.7064 140.586 88.8767 139.894 88.2913 138.909C87.0938 136.898 86.2156 134.715 85.6142 132.448C85.3534 131.453 84.8425 131.016 83.8579 130.782C79.366 129.712 74.8954 128.568 70.4141 127.445C68.4449 126.95 67.8488 126.194 67.8382 124.156C67.8275 122.261 67.8701 120.361 67.8275 118.466C67.7903 116.891 68.5247 115.885 69.9883 115.502C74.0811 114.437 78.1898 113.447 82.2879 112.415C82.9478 112.25 83.4162 112.388 83.9164 112.894C90.0529 119.068 96.2213 125.215 102.363 131.378C102.752 131.767 103.044 132.256 103.342 132.725C108.175 140.373 117.175 144.274 125.685 142.401C134.828 140.389 141.449 133.337 142.561 124.135C143.621 115.39 140.188 108.599 133.04 103.617C132.119 102.978 131.246 102.313 130.459 101.514C124.706 95.745 118.958 89.9756 113.167 84.2434C112.449 83.5302 112.209 82.8809 112.47 81.9016C113.439 78.2451 114.333 74.5674 115.275 70.9056C115.956 68.2444 116.461 67.8612 119.202 67.8612C119.926 67.8612 120.655 67.8612 121.379 67.8612L121.39 67.8559Z",
    fill: "url(#paint0_linear_75_677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.475 99.9489C117.084 100.215 113.348 101.194 110.011 103.398C109.335 103.845 108.931 103.653 108.441 103.148C107.041 101.705 105.61 100.3 104.194 98.8791C88.0251 82.7097 71.867 66.5298 55.6663 50.3924C54.6711 49.4024 54.4529 48.8595 55.6184 47.827C57.6143 46.0493 59.5036 44.1386 61.2972 42.1534C62.2712 41.0729 62.7874 41.2433 63.7401 42.196C81.6918 60.2121 99.686 78.1857 117.67 96.17C118.84 97.3409 120.027 98.5065 121.48 99.9542L121.475 99.9489Z",
    fill: "url(#paint1_linear_75_677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.9521 121.52C95.7263 117.262 91.8198 113.303 87.8867 109.369C72.6706 94.1421 57.4599 78.9148 42.2065 63.7195C41.2486 62.7668 41.0942 62.2505 42.1693 61.2765C44.1917 59.4403 46.1237 57.4976 47.9651 55.4858C48.8965 54.4639 49.4021 54.6555 50.2856 55.539C67.7689 73.0708 85.2789 90.5814 102.81 108.065C103.603 108.853 103.837 109.38 103.151 110.434C101.075 113.633 100.192 117.241 99.9521 121.526V121.52Z",
    fill: "url(#paint2_linear_75_677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.315 137.493C112.459 137.471 105.343 130.275 105.359 121.355C105.375 112.419 112.592 105.319 121.619 105.362C130.453 105.404 137.521 112.627 137.489 121.579C137.457 130.425 130.246 137.519 121.315 137.493Z",
    fill: "url(#paint3_linear_75_677)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.8585 35.5862C49.7428 42.7022 42.7016 49.7384 35.5858 56.8544C34.6065 54.1985 33.59 51.4522 32.5735 48.7005C30.1732 42.2445 27.7888 35.7778 25.3779 29.3165C24.8989 28.0338 24.718 26.815 25.8037 25.7612C26.8202 24.7659 27.9751 24.883 29.2152 25.3407C38.1777 28.6725 47.1456 31.9777 56.1134 35.2935C56.3689 35.3893 56.6137 35.4904 56.8585 35.5862Z",
    fill: "url(#paint4_linear_75_677)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_677",
    x1: 121.409,
    y1: 67.8379,
    x2: 121.409,
    y2: 174.998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_677",
    x1: 88.1547,
    y1: 41.4102,
    x2: 88.1547,
    y2: 103.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_677",
    x1: 72.4898,
    y1: 54.7949,
    x2: 72.4898,
    y2: 121.526,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_677",
    x1: 121.424,
    y1: 105.361,
    x2: 121.424,
    y2: 137.493,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_677",
    x1: 40.9294,
    y1: 25,
    x2: 40.9294,
    y2: 56.8544,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4C135"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E98432"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_677"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 150,
    height: 150,
    fill: "white",
    transform: "translate(25 25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizableExperience);
export default __webpack_public_path__ + "static/media/Customizable_Experience.c1f806ef802f125bf3d3cb0944745d5a.svg";
export { ForwardRef as ReactComponent };